const Assistance618 = () => import(/* webpackChunkName: 'assistance618' */ "views/Activities/Assistance618/Index.vue")
export default [
  {
    path: '/assistance618',
    name: "assistance618",
    component: Assistance618
  }
]